module.exports = __webpack_public_path__ + "img/new-logo1.85035206.png";